import { Component, Input, OnInit } from '@angular/core';
import { NeskoAbObjekteDetailEntryMeta } from 'app/core/amtlichebewertung-api';
import { ListLoaderObservable } from 'app/shared/components/list-loader/list-loader-observable';
import { of } from 'rxjs';
import { ListLoader } from 'app/shared/components/list-loader/list-loader';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { RubrikComponent } from '../../../shared/components/rubrik/rubrik.component';
import { ListLoaderWrapperComponent } from '../../../shared/components/list-loader-wrapper/list-loader-wrapper.component';
import { NgTemplateOutlet } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { BetragPipe } from '../../../shared/pipes/simple/betrag.pipe';
import { DecimalHochkommaPipe } from '../../../shared/pipes/simple/decimalHochkomma.pipe';

@Component({
  selector: 'cap-objekte',
  templateUrl: './objekte.component.html',
  styleUrls: ['./objekte.component.scss'],
  imports: [RubrikComponent, ListLoaderWrapperComponent, NgTemplateOutlet, TranslatePipe, BetragPipe, DecimalHochkommaPipe]
})
export class ObjekteComponent implements OnInit {
  _objekte: Array<NeskoAbObjekteDetailEntryMeta>;

  listLoader: ListLoader<NeskoAbObjekteDetailEntryMeta>;

  @Input()
  hasRight = false;

  @Input()
  isAmtlicherWertVerteilt = true;

  constructor() {
    keysToTranslate<string>([
      'Objekt-Nr.',
      'Objektcode',
      'Lagebezeichnung',
      'Objektbezeichnung',
      'Gebaeude-Nr.',
      'Flaeche',
      'neskoab.AmtlicherWert',
      'neskoab.Objekte'
    ]);
  }

  ngOnInit() {}

  @Input()
  set objekte(value: Array<NeskoAbObjekteDetailEntryMeta>) {
    if (!value) {
      return;
    }
    this.listLoader = new ListLoaderObservable<NeskoAbObjekteDetailEntryMeta>(undefined, 1, of(value));
    this._objekte = value;
  }
}
